<template>
  <div
    v-if="!isLoadingDetail && !isUploadingNewRainDetail"
    class="modern-campaign-detail animation-slide"
  >
    <!-- Edit Actions -->
    <HeaderSection :detail="detail" :showActionbtn="true" @clone-rain="cloneChallenge" />

    <SummaryCard
      v-if="skinId && campaignId"
      title="Summary"
      :cardsInfo="[
        {
          label: 'Active',
          icon: 'fa-solid fa-user',
          value: detail?.players_count?.active ?? 0,
        },
        {
          label: 'Awarded',
          icon: 'fa-solid fa-trophy',
          value: detail?.players_count?.awarded ?? 0,
        },
      ]"
      :dataLoaded="dataLoaded"
    />

    <SummaryCampaign
      v-if="0 && skinId && campaignId"
      title="Played on prizes"
      :cardsData="cardsData"
      :cardsInfo="[
        {
          label: 'Total Bets',
          icon: 'fa-solid fa-layer-group',
          type: 'totalBets',
          property: 'totalBets',
        },
        {
          label: 'Total Wins',
          icon: 'fa-solid fa-trophy',
          type: 'totalWins',
          property: 'totalWins',
        },
        {
          label: 'Net Result',
          icon: 'fa-solid fa-chart-line',
          type: 'net',
        },
      ]"
      :campaign_id="campaignId"
      :currency_code="detail.currency_code ?? 'EUR'"
      :skin_id="skinId"
      :showCurrencySwitcher="true"
      :showEuro="true"
      :dataLoaded="dataLoaded"
      @toggle-currency="showEuro = $event"
    />

    <div v-if="detail && editableDetail" class="detail-container">
      <div class="detail-sections">
        <FieldSection
          :detail="detail"
          :editableDetail="editableDetail"
          :keys="[
            'title',
            'mode',
            'games',
            'is_enabled',
            'description',
            'note',
            'skin_id',
          ]"
          title="General Information"
          icon="clipboard"
          :getIconClass="getIconClass"
          :iconColor="'text-primary'"
          :formatLabel="formatLabel"
          :formatVal="formatVal"
          :typeOptions="typeOptions"
          :allowedSkins="allowedSkins"
          :validateHourInput="validateHourInput"
        />

        <FieldSection
          :detail="detail"
          :editableDetail="editableDetail"
          :keys="[
            'start_date',
            'end_date',
            'announcement_date',
            'created_at',
            'updated_at',
          ]"
          title="Schedule & Timing"
          icon="calendar-days"
          :getIconClass="getIconClass"
          :iconColor="'text-info'"
          :formatLabel="formatLabel"
          :formatVal="formatVal"
          :typeOptions="typeOptions"
          :allowedSkins="allowedSkins"
          :validateHourInput="validateHourInput"
        />

        <FieldSection
          :detail="detail"
          :editableDetail="editableDetail"
          :keys="['currency', 'min_bet', 'max_bet']"
          title="Configuration"
          icon="gears"
          :getIconClass="getIconClass"
          :iconColor="'text-success'"
          :formatLabel="formatLabel"
          :formatVal="formatVal"
          :typeOptions="typeOptions"
          :allowedSkins="allowedSkins"
          :validateHourInput="validateHourInput"
        />
        <FieldSection
          :detail="detail"
          :editableDetail="editableDetail"
          :keys="['background']"
          title="Appearance"
          icon="gears"
          :getIconClass="getIconClass"
          :formatLabel="formatLabel"
          :iconColor="'text-muted'"
          :formatVal="formatVal"
          :typeOptions="typeOptions"
          :allowedSkins="allowedSkins"
          :validateHourInput="validateHourInput"
        />
        <!-- tasks -->
        <div class="space-y-6">
          <section
            v-if="detail.tasks?.length"
            class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden"
          >
            <div
              class="flex items-center gap-1 px-3 py-3 border-b border-gray-100 bg-gray-50/50 flex items-center gap-1 w-full"
            >
              <div
                class="w-8 h-8 rounded bg-amber-50 flex items-center justify-center text-amber-600"
              >
                <i class="fa-solid fa-list-check text-sm"></i>
              </div>
              <h2
                class="text-xs font-bold text-slate-700 uppercase tracking-wider"
              >
                Tasks
              </h2>
            </div>

            <div class="p-6 space-y-4">
              <div
                v-for="(task, index) in detail.tasks"
                :key="'task-' + index"
                class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 p-4 rounded-xl border border-slate-100 bg-slate-50/30"
              >
                <div class="flex items-center gap-3">
                   
                  <div class="flex flex-col">
                    <span
                      class="text-slate-500 text-[10px] font-bold uppercase tracking-tight tracking-tight"
                      >Type</span
                    >
                    <span class="text-sm font-bold text-slate-700">
                      {{
                        task.type
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase())
                      }}
                    </span>
                  </div>
                </div>

                <div class="flex items-center gap-3">
                  
                  <div class="flex flex-col">
                    <span
                      class="text-slate-500 text-[10px] font-bold uppercase tracking-tight tracking-tight"
                      >{{ getLabelTask(task.type) }}</span
                    >
                    <span class="text-sm font-bold text-slate-700">{{
                      formatVal("task_value", task.value)
                    }}</span>
                  </div>
                </div>

                <div class="flex items-center gap-3">
                  
                  <div class="flex flex-col">
                    <span
                      class="text-slate-500 text-[10px] font-bold uppercase tracking-tight tracking-tight"
                      >Min Bet</span
                    >
                    <span class="text-sm font-bold text-slate-700">{{
                      formatVal("task_min_bet", task.min_bet)
                    }}</span>
                  </div>
                </div>

                <div class="flex items-center gap-3">
                  
                  <div class="flex flex-col">
                    <span
                      class="text-slate-500 text-[10px] font-bold uppercase tracking-tight tracking-tight"
                      >Max Bet</span
                    >
                    <span class="text-sm font-bold text-slate-700">{{
                      formatVal("task_max_bet", task.max_bet)
                    }}</span>
                  </div>
                </div>

                <div
                  v-if="task.type === 'catch_multipliers'"
                  class="flex items-center gap-3 md:col-span-2"
                >
                  
                  <div class="flex flex-col">
                    <span
                      class="text-slate-500 text-[10px] font-bold uppercase tracking-tight tracking-tight"
                      >{{ getLabelMultiplier(task.type) }}</span
                    >
                    <span class="text-sm font-bold text-slate-700">{{
                      formatVal(
                        "task_multiplier_reached",
                        task.multiplier_reached,
                      )
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            v-if="detail?.prizes?.length"
            class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden"
          >
            <div
              class="flex items-center gap-1 px-3 py-3 border-b border-gray-100 bg-gray-50/50 flex items-center gap-1 w-full"
            >
              <div
                class="w-8 h-8 rounded bg-rose-50 flex items-center justify-center text-rose-600"
              >
                <i class="fa fa-trophy text-sm"></i>
              </div>
              <h2
                class="text-xs font-bold text-slate-700 uppercase tracking-wider"
              >
                Prize Configuration
              </h2>
            </div>

            <div class="p-6 space-y-4">
              <div
                v-if="detail.mode === 'race'"
                class="inline-flex items-center gap-3 p-3 rounded-lg border border-rose-100 bg-rose-50/30 mb-2"
              >
                <i
                  :class="[getIconClass('prize_typeprize'), 'text-rose-500']"
                ></i>
                <span class="text-xs font-bold text-slate-500 uppercase"
                  >Max players:</span
                >
                <span class="text-sm font-black text-rose-600">{{
                  detail.max_players
                }}</span>
              </div>

              <div
                v-for="(prize, index) in detail.prizes"
                :key="'prize-' + index"
                class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6 p-3 rounded-xl border border-slate-100 hover:border-rose-200 transition-colors"
              >
                <template v-if="detail?.mode === 'tournament'">
                  <div class="flex flex-col">
                    <span class="text-slate-500 text-[10px] font-bold uppercase tracking-tight"
                      >Min Rank</span
                    >
                    <span class="text-sm font-bold text-slate-700">{{
                      prize?.min_rank
                    }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-slate-500 text-[10px] font-bold uppercase tracking-tight"
                      >Max Rank</span
                    >
                    <span class="text-sm font-bold text-slate-700">{{
                      prize?.max_rank
                    }}</span>
                  </div>
                </template>

                <div class="flex flex-col">
                  <span class="text-slate-500 text-[10px] font-bold uppercase tracking-tight"
                    >Type Prize</span
                  >
                  <span class="text-sm font-bold text-rose-600">{{
                    toTitleCase(prize?.typeprize)
                  }}</span>
                </div>

                <div
                  v-if="prize?.typeprize === 'freebets_boost'"
                  class="flex flex-col"
                >
                  <span class="text-slate-500 text-[10px] font-bold uppercase tracking-tight"
                    >Boost</span
                  >
                  <span class="text-sm font-bold text-slate-700"
                    >{{ prize?.boost }}X</span
                  >
                </div>

                <template v-if="prize?.typeprize !== 'custom'">
                  <div class="flex flex-col">
                    <span class="text-slate-500 text-[10px] font-bold uppercase tracking-tight"
                      >Quantity</span
                    >
                    <span class="text-sm font-bold text-slate-700">{{
                      prize?.quantity
                    }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-slate-500 text-[10px] font-bold uppercase tracking-tight"
                      >Amount</span
                    >
                    <span class="text-sm font-bold text-slate-700">{{
                      prize?.amount
                    }}</span>
                  </div>
                   
                </template>

                <div
                  v-if="prize?.typeprize === 'custom'"
                  class="flex flex-col col-span-2"
                >
                  <span class="text-slate-500 text-[10px] font-bold uppercase tracking-tight"
                    >Link</span
                  >
                  <span
                    class="text-sm font-medium text-blue-600 truncate underline"
                    >{{ prize?.link }}</span
                  >
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
  <div
    class="w-100 d-flex align-items-center justify-content-center h-auto pt-5"
    v-else
  >
    <Loader />
  </div>

  <ChallengeCloneModal
    v-if="isCloningChallenges"
    :detail="challegeClone"
    :closeChallengeClone="cloneChallenge"
  />
</template>

<script>
//Utility
import { format } from "date-fns";
import { mapGetters } from "vuex";

//axios method to make api call
import { getFetch, putFetch } from "@/api/axiosClient";

// Reusable component
import Swal from "sweetalert2";
import Loader from "../Loader.vue";

//Rain Info Child Components
import HeaderSection from "../RainComponent/HeaderSection.vue";
import FieldSection from "../RainComponent/FieldSection.vue";
import BudgetCard from "../RainComponent/BudgetCard.vue";
import SummaryCampaign from "../SummaryCampaign.vue";
import SummaryCard from "../Utility/SummaryCard.vue";
import ChallengeCloneModal from "./ChallengeCloneModal.vue";

export default {
  name: "ChallengeInfo",
  components: {
    Loader,
    HeaderSection,
    FieldSection,
    BudgetCard,
    SummaryCampaign,
    SummaryCard,
    ChallengeCloneModal,
  },
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
    campaignId: {
      type: String,
      required: true,
    },
    isLoadingDetail: {
      type: Boolean,
      default: false,
    },
    saveDetail: Function,
  },
  computed: {
    ...mapGetters(["allowedSkins", "allowedGamesFreebet"]),
    skinId() {
      return this.detail?.skin_id ?? null;
    },
  },
  data() {
    return {
      canShowSummary: false,
      gameChoose: {},
      typeOptions: {
        all: "All",
        cashout_1: "Cashout 1",
        cashout_2: "Cashout 2",
        oddeven: "Odd/Even",
        ranges: "Ranges",
        cashout_1_cashout_2: "Cashout 1 + Cashout 2",
        cashout_1_oddeven: "Cashout 1 + Odd/Even",
        cashout_1_ranges: "Cashout 1 + Ranges",
        cashout_2_oddeven: "Cashout 2 + Odd/Even",
        cashout_2_ranges: "Cashout 2 + Ranges",
        oddeven_ranges: "Odd/Even + Ranges",
        cashout_1_cashout_2_oddeven: "Cashout 1 + Cashout 2 + Odd/Even",
        cashout_1_cashout_2_ranges: "Cashout 1 + Cashout 2 + Ranges",
        cashout_1_oddeven_ranges: "Cashout 1 + Odd/Even + Ranges",
        cashout_2_oddeven_ranges: "Cashout 2 + Odd/Even + Ranges",
      },
      editableDetail: {},
      isUploadingNewRainDetail: false,
      isRainTimeModalOpen: false,
      cardsData: [],
      dataLoaded: false,
      isCloningChallenges: false,
      challegeClone: {},
    };
  },
  async beforeCreate() {},
  async mounted() {
    this.getCost();
  },
  watch: {
    detail: "getCost",
  },
  methods: {
    getLabelMultiplier(taskType) {
      const labels = {
        play_rounds: "Multiplier is Reached",
        catch_multipliers: "Min Multiplier",
      };
      return labels[taskType] || "Value*";
    },
    getDescMultiplier(taskType) {
      const labels = {
        play_rounds:
          "Optional: To complete this task, player should make a bet in a round where entered multiplier was reached. The task is completed both if he wins or loses the round. Example: You entered 10x here. If player has placed a bet in a round where multiplier goes to 10x or more, this task is completed.",
        catch_multipliers: "minimum multiplier to complete the task.",
      };
      return labels[taskType] || "Value*";
    },
    toTitleCase(str = "") {
      return str
        .trim()
        .replace("_", " ")
        .replace(/\s+/g, " ") // rimuove spazi extra
        .toLowerCase() // tutto minuscolo
        .replace(/\b\w/g, (c) => c.toUpperCase()); // prima lettera maiuscola
    },
    async getCost() {
      this.dataLoaded = true;
      return;
      if (this.detail?.skin_id && this.campaignId) {
        try {
          let query = {
            skin_id: this.detail?.skin_id,
          };

          if (this.campaignId) {
            query.campaign_id = this.campaignId;
          }

          let data = await getFetch("/freebets/calculate-costs", query);

          this.cardsData = data;
          // console.log(this.cardsData);
          this.dataLoaded = true;
        } catch (error) {
          console.error("Error fetching cost data:", error);
          this.dataLoaded = true;
        }
      }
    },
    formatCampaignType(type) {
      const typeOptions = {
        all: "All",
        cashout_1: "Cashout 1",
        cashout_2: "Cashout 2",
        oddeven: "Odd/Even",
        ranges: "Ranges",
        cashout_1_cashout_2: "Cashout 1 + Cashout 2",
        cashout_1_oddeven: "Cashout 1 + Odd/Even",
        cashout_1_ranges: "Cashout 1 + Ranges",
        cashout_2_oddeven: "Cashout 2 + Odd/Even",
        cashout_2_ranges: "Cashout 2 + Ranges",
        oddeven_ranges: "Odd/Even + Ranges",
        cashout_1_cashout_2_oddeven: "Cashout 1 + Cashout 2 + Odd/Even",
        cashout_1_cashout_2_ranges: "Cashout 1 + Cashout 2 + Ranges",
        cashout_1_oddeven_ranges: "Cashout 1 + Odd/Even + Ranges",
        cashout_2_oddeven_ranges: "Cashout 2 + Odd/Even + Ranges",
      };
      return typeOptions[type] || null;
    },
    formatCurrency(amount) {
      if (!amount && amount !== 0) return "0.00";
      return `${parseFloat(amount).toFixed(2)}`;
    },

    cloneChallenge(show = true) {
      if (show) {
        this.isCloningChallenges = true;
        this.challegeClone = { ...this.detail };
        // console.log("CLONE CHALLENGE DETAIL", this.challegeClone);
      } else {
        this.isCloningChallenges = false;
        this.challegeClone = {};
      }
    },

    getLabelTask(taskType) {
      const labels = {
        bet_total: "Total Bets",
        collect_multipliers: "Total Multipliers",
        play_rounds: "Total Rounds",
        win_money: "Total Win Amount",
        win_rounds: "Total Win Rounds",
        catch_multipliers: "Number of times",
      };
      return labels[taskType] || "";
    },
    formatLabel(key) {
      return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },

    formatVal(key, value) {
      if (value === null || value === undefined) return "N/A";

      switch (key) {
        case "is_enabled":
          return value ? "Enabled" : "Disabled";
        case "created_at":
        case "updated_at":
          return format(new Date(value), "dd/MM/yyyy HH:mm");
        case "start_date":
        case "announcement_date":
        case "end_date":
          return format(new Date(value), "dd/MM/yyyy HH:mm");
        case "start_time":
        case "end_time":
          return value.toString().includes(":") ? value : `${value}:00`;
        case "amount":
        case "min_cashout":
        case "min_balance":
        case "type":
          return this.typeOptions[value] || value;
        default:
          return value.toString();
      }
    },

    getIconClass(key) {
      const iconMap = {
        title: "bi bi-card-heading",
        description: "bi bi-card-text",
        note: "bi bi-sticky",
        type: "bi bi-tags",
        skin_id: "bi bi-palette",
        _id: "bi bi-hash",
        is_enabled: "bi bi-toggle-on",
        start_date: "bi bi-calendar-date",
        end_date: "bi bi-calendar-check",
        start_time: "bi bi-clock",
        end_time: "bi bi-clock-fill",
        duration: "bi bi-hourglass-split",
        deadline: "bi bi-alarm",
        created_at: "bi bi-calendar-plus",
        updated_at: "bi bi-calendar-plus",
        announcement_date: "bi bi-calendar-plus",
        max_players: "bi bi-people",
        count_day_freebet: "bi bi-gift",
        amount: "bi bi-currency-dollar",
        currency_code: "bi bi-cash-coin",
        currency: "bi bi-cash-coin",
        claim_limitation_period: "bi bi-calendar-range",
        claim_limitation_daily: "bi bi-calendar-day",
        min_cashout: "bi bi-rocket-takeoff-fill",
        min_balance: "bi bi-wallet2",
        total_budget: "bi bi-wallet",
        day_budget: "bi bi-calendar-day",
        min_wager: "bi bi-bullseye",
        quantity: "bi bi-123",
        mode: "bi bi-toggle2-on",
        game_id: "bi bi-controller",
        min_bet: "bi bi-arrow-down-circle",
        max_bet: "bi bi-arrow-up-circle",
        background: "bi bi-image",
        type: "",
        total_bets: "",
      };
      return iconMap[key] || "bi bi-info-circle";
    },

    handleNumericInput(event, key) {
      let input = event.target.value;
      if (input === "") input = "0";
      input = input.replace(/,/g, ".");
      input = input.replace(/[^0-9.]/g, "");

      const parts = input.split(".");
      if (parts.length > 2) {
        input = parts[0] + "." + parts.slice(1).join("");
      }

      if (input.includes(".")) {
        const [intPart, decimalPart] = input.split(".");
        input = intPart + "." + decimalPart.slice(0, 2);
      }

      this.editableDetail[key] = input;
    },

    validateHourInput(key) {
      let rawValue = this.editableDetail[key];

      let hourPart = String(rawValue).split(":")[0].replace(/\D/g, "");

      let hour = parseInt(hourPart, 10);
      if (isNaN(hour)) hour = 0;

      if (hour < 0) hour = 0;
      if (hour > 23) hour = 23;

      const formatted = hour.toString().padStart(2, "0") + ":00";

      this.editableDetail[key] = formatted;

      const start = parseInt(this.editableDetail.start_time?.split(":")[0], 10);
      const end = parseInt(this.editableDetail.end_time?.split(":")[0], 10);

      if (start === 0 && end === 0) {
        this.editableDetail.end_time = "01:00";
      }

      if (start === end) {
        this.editableDetail.end_time =
          (start < 23 ? (start + 1).toString().padStart(2, "0") : "23") + ":00";
      }

      if (end < start) {
        this.editableDetail.end_time =
          (start < 23 ? (start + 1).toString().padStart(2, "0") : "23") + ":00";
      }

      if (start === 23) {
        this.editableDetail.start_time = "22:00";
      }
    },

    async saveChanges() {
      let dataToSend = { ...this.editableDetail };

      const cleanDate = (dateString) => {
        return dateString.split(" ")[0];
      };

      const convertDateToISOString = (dateString, type = "start") => {
        const cleanedDate = cleanDate(dateString);
        const [year, month, day] = cleanedDate.split("-");
        const time = type === "start" ? "T00:00:00.000Z" : "T23:59:59.999Z";
        const date = new Date(`${year}-${month}-${day}${time}`);
        return isNaN(date) ? null : date.toISOString();
      };

      const dateFields = [
        { key: "start_date", type: "start" },
        { key: "end_date", type: "end" },
      ];

      for (const { key, type } of dateFields) {
        if (dataToSend[key]) {
          const iso = convertDateToISOString(dataToSend[key], type);
          if (iso) {
            dataToSend[key] = iso;
          } else {
            Swal.fire({
              title: "Error!",
              text: `Invalid date format in ${key.replace("_", " ")}.`,
              icon: "error",
            });
            return;
          }
        }
      }

      ["start_time", "end_time"].forEach((timeField) => {
        if (dataToSend[timeField] !== undefined) {
          let time = dataToSend[timeField].trim();

          if (/^\d{1,2}:\d{2}:\d{2}$/.test(time)) {
            const [hh, mm] = time.split(":");
            dataToSend[timeField] = `${hh.padStart(2, "0")}:${mm}`;
          } else if (/^\d{1,2}:\d{2}$/.test(time)) {
            const [hh, mm] = time.split(":");
            dataToSend[timeField] = `${hh.padStart(2, "0")}:${mm}`;
          } else if (/^\d{1,2}$/.test(time)) {
            dataToSend[timeField] = `${time.padStart(2, "0")}:00`;
          } else {
            dataToSend[timeField] =
              timeField === "start_time" ? "00:00" : "23:59";
          }
        }
      });

      const numericFields = [
        "day_budget",
        "min_cashout",
        "min_balance",
        "total_budget",
        "amount",
      ];
      numericFields.forEach((field) => {
        if (dataToSend[field] !== undefined) {
          dataToSend[field] = parseFloat(dataToSend[field]).toFixed(2);
        }
      });

      this.isUploadingNewRainDetail = true;

      try {
        await putFetch(`/campaigns/${this.detail?._id}`, dataToSend);

        Swal.fire("Success!", "The Rain detail has been updated.").then(() => {
          window.location.reload();
        });
      } catch (error) {
        console.error("Error updating Rain detail:", error);
        Swal.fire({
          title: "Error",
          text: "Failed to update the Rain detail.",
          icon: "error",
        });
      } finally {
        this.isUploadingNewRainDetail = false;
      }
    },
    toggleRainTimeModal() {
      this.isRainTimeModalOpen = !this.isRainTimeModalOpen;
      if (!this.isRainTimeModalOpen) {
        this.rainTimeGenerated = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("@/assets/styles/components/rainInfo.scss");
</style>
